<template>
  <div class="wrap-box">
    <div class="top-box">
      <div class="content-box">
        <!-- 订单信息 -->
        <div
          class="card-box card-padding-24"
          v-if="!isShowTrailer"
        >
          <div
            class="card-tips-warning"
            v-if="
              taskDetail.isPaicOrder === 1 ||
                (taskDetail.pingAnServiceFinishedPageConfig &&
                taskDetail.pingAnServiceFinishedPageConfig.topPrompt)
            "
          >
            <img
              src="@/assets/img/icon_warning.png"
              alt=""
            >
            <!-- <span class="tips-txt">请务必引导客户5星好评、再去好车主app打10分</span> -->
            <span class="tips-txt">
              {{
                taskDetail.pingAnServiceFinishedPageConfig
                  ? taskDetail.pingAnServiceFinishedPageConfig.topPrompt ||
                    topPromptDefaultText
                  : topPromptDefaultText
              }}
            </span>
          </div>
          <div
            class="card-title card-title__center"
            v-else
          >
            <span>已到达目的地，本次拖车里程</span>
            <span class="color-orange">{{
              getCeilNum(
                taskDetail.appealDistance || taskDetail.orderMileage || 0
              )
            }}</span>
            <span>公里，请提醒客户记得</span>
            <span class="color-orange">打开链接给予本次服务好评！</span>
          </div>
          <van-divider style="margin: 24px 0" />
          <van-row
            gutter="12"
            class="info-item"
          >
            <van-col :span="12">
              <span class="item-label">申诉里程：</span>
              <span>{{ getCeilNum(taskDetail.appealDistance || 0) }}公里</span>
            </van-col>
            <van-col :span="12">
              <span class="item-label">救援环境：</span>
              <span>{{ currentEnv }}</span>
            </van-col>
          </van-row>
          <van-row
            gutter="12"
            class="info-item"
          >
            <van-col :span="12">
              <span class="item-label">辅轮数量：</span>
              <span>{{ trainingWheels || "无" }}</span>
            </van-col>
            <van-col :span="12">
              <span class="item-label">地库牵引：</span>
              <span>{{ useShopDrawing ? "有" : "无" }}</span>
            </van-col>
          </van-row>
          <van-row
            gutter="12"
            class="info-item"
          >
            <van-col :span="24">
              <span class="item-label">优惠信息：</span>
              <span>{{ rightRemark }}</span>
            </van-col>
          </van-row>
        </div>
        <div
          v-if="isShowTrailer"
          class="card-box card-padding"
        >
          <div class="car-info-item">
            <span>订单编号：</span>
            <span
              class="car-no order-no"
              :class="{
                'color-red': taskDetail.vipCompany === '1',
                'order-svip': isZvVipAndVipCompany,
              }"
            >{{ taskDetail.orderNo || "-" }}</span>
            <div
              class="zv-vip-icon"
              v-if="isShowZvVip"
            >至尊VIP</div>
            <div
              class="zv-vip-icon"
              v-if="isShowBcCustomer"
            >黑钻客户</div>
            <img
              v-if="taskDetail.vipCompany === '1'"
              src="@/assets/img/orderGeneral/vipCompany.png"
              class="vip-icon"
            >
            <div>
              <div
                class="copy"
                @click="copy"
              >复制</div>
            </div>
          </div>
          <div class="car-info-item">
            <span>服务类型：</span>
            <span class="car-no">{{
              taskDetail.productCategoryName || "-"
            }}</span>
          </div>
          <div class="card-extra">
            <div class="card-title">服务项目</div>
            <div class="extraProduct">
              <div
                v-for="(item, index) in taskDetail.extraProduct"
                :key="index"
                class="extraProductList"
              >
                <span class="extraIndex">{{ index + 1 }}</span>
                <span class="extraTitle">{{ item.title }}:</span>
                <span>{{ item.name
                }}{{ item.desc === "D01" ? `${item.value}个` : ""
                }}{{
                  item.desc.substring(0, 1) === "A" &&
                    (taskDetail.appealDistance || taskDetail.orderMileage)
                    ? `（${
                      taskDetail.appealDistance || taskDetail.orderMileage
                    }公里）`
                    : ""
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 终点地标 -->
        <div
          class="card-box card-padding"
          v-if="!isShowTrailer"
        >
          <div class="card-title card-title-flex">
            <span>终点地标</span>
          </div>
          <van-field
            :readonly="!!taskDetail.actualGarageName"
            class="input-box"
            v-model="dataForm.address"
            placeholder="请输入修理厂/4S店/加油站/充电站名称"
          />
        </div>
        <!-- 服务完成照片详情 -->
        <div class="card-box card-padding">
          <div class="card-title card-title-flex">
            <div class="">
              <span>服务完成照片详情</span>
              <span
                class="card-tips__gary"
                v-if="isShowTrailer"
              >（根据所选服务需拍摄对应的凭证）</span>
              <span
                class="card-tips card-tips__red"
                v-if="!isShowTrailer"
              >（缺失{{
                (imageInfo.photoNumAll || 0) - (imageInfo.photoNumTaked || 0)
              }}张照片）</span>
            </div>
            <div
              class="card-title-info"
              v-if="!isShowTrailer"
            >
              <span>{{ imageInfo.photoNumTaked || 0 }}/{{
                imageInfo.photoNumAll || 0
              }}</span>
              <van-icon name="arrow" />
            </div>
          </div>
          <div
            class="card-info"
            v-if="isShowTrailer"
          >
            已拍摄{{ imageInfo.photoNumTaked || 0 }}，还需拍摄<span
              class="card-tips card-tips__red"
            >{{
              (imageInfo.photoNumAll || 0) - (imageInfo.photoNumTaked || 0)
            }}</span>张
          </div>
          <van-button
            type="info"
            size="large"
            @click="toPhoto"
          >去拍照</van-button>
        </div>

        <!-- 电子工单 -->
        <div
          class="card-box card-padding"
          v-if="isDifficultyRelief || isRoadside"
        >
          <div
            class="card-title card-title-flex"
            @click="goWorkOrders"
          >
            <div class="card-flex">
              <img
                class="takeImg"
                src="@/assets/img/take_photo.png"
                alt=""
              >电子工单
            </div>
            <div>
              <span
                class="stateInfo"
                :class="{ isStateInfo: !isPerfection }"
                v-if="isTrailer && isWorkEndStatus"
              >{{ isPerfection ? "已完善" : "未完善" }}</span>
              <van-icon name="arrow" />
            </div>
          </div>
        </div>

        <!-- 订单费用 -->
        <div
          class="card-box card-padding"
          v-if="!isShowTrailer"
        >
          <div class="card-title flex-box">
            <span>订单费用</span>
            <span
              class="card-tag card-tag__red"
              v-if="taskDetail.appOrderPayType"
            >{{ taskDetail.appOrderPayType }}</span>
          </div>
          <van-divider style="margin: 16px -16px" />
          <div class="card-title">
            <div
              class="card-tips card-tips__red card-tips__small card-tips__margin"
            >
              订单有超出签单范围，请填写对应的费用情况
            </div>
          </div>
          <div class="card-title card-title-flex">
            <div class="card-title-info">收客户现金登记</div>
            <div
              class="card-text-btn"
              @click="openEntryBox"
            >录入</div>
          </div>
        </div>
        <!-- 确认弹窗 -->
        <ConfirmDialog ref="confirmDialog" />
        <!-- 订单费用录入 -->
        <OrderCostEntryBox ref="orderCostEntryBox" />
      </div>
    </div>
    <div class="bottom-box">
      <!-- 底部滑动条 -->
      <ClickButton
        ref="clickButton"
        @sliderCompleted="sliderCompleted"
      >
        点击执行完成
      </ClickButton>
    </div>
    <OrderReport
      is-in-app
      :task-detail="taskDetail"
    />
  </div>
</template>

<script>
import { paicProductCode, TASK_STATUS_CODE } from '@/common/constant';
import ClickButton from '@/components/clickButton.vue';
import ConfirmDialog from '@/components/confirmDialog.vue';
import OrderReport from '@/components/orderReport.vue';
import OrderCostEntryBox from './components/orderCostEntryBox.vue';
import {
  getTaskDetail,
  getRightRemark,
  checkPictureNum,
  savePictureTemplate,
  finishWork,
  getRescueReport,
  getMediaTemplate
} from '@/common/apiPaic.js';
import { queryDictByCodes } from '@/common/api.js';
import jsApi from '@/common/jsApi';
import { handleClipboard } from '@/common/clipboard';
import Util from '@/common/util.js';
const initDataForm = () => {
  return {
    address: ''
  };
};

export default {
  components: {
    ClickButton,
    ConfirmDialog,
    OrderReport,
    OrderCostEntryBox
  },
  data() {
    return {
      dataForm: initDataForm(),
      taskDetail: {},
      imageInfo: {},
      orderNo: '',
      taskNo: '',
      currentEnvList: [],
      trainingWheels: '',
      useShopDrawing: false,
      imageCompleted: false,
      rightRemark: '',
      isShowTrailer: true,
      reportData: {},
      copyText: ''
    };
  },
  created() {
    const { orderNo, taskNo } = this.$route.params;
    if (orderNo && taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
    }
    // 定义提供给原生调用的方法
    window.webViewDidAppear = () => {
      this.checkPictureNum();
    };
  },
  computed: {
    // 拖车
    isTrailer() {
      return (
        this.taskDetail &&
        [paicProductCode.categoryCode_FL10000002].includes(
          this.taskDetail.categoryCode
        )
      );
    },
    // 地库拖车
    isBasementTrailer() {
      return (
        this.taskDetail &&
        [paicProductCode.categoryCode_FL10000003].includes(
          this.taskDetail.categoryCode
        )
      );
    },
    // 困境救援
    isDifficultyRelief() {
      return (
        this.taskDetail &&
        [paicProductCode.categoryCode_FLA0000002].includes(
          this.taskDetail.categoryCode
        )
      );
    },
    // 道路救援
    isRoadside() {
      return (
        this.taskDetail &&
        [paicProductCode.categoryCode_FL10000001].includes(
          this.taskDetail.categoryParentCode
        )
      );
    },
    currentEnv() {
      const env =
        this.currentEnvList.find(
          (item) => item.key === this.taskDetail.rescueCurrentEnv
        ) || {};
      return env.value || '';
    },
    // 是否完善
    isPerfection() {
      return (
        this.reportData &&
        this.reportData.customerSign &&
        this.reportData.operatorSign &&
        this.reportData.carStatus
      );
    },
    // 是否作业结束
    isWorkEndStatus() {
      return this.taskDetail.taskStatus === TASK_STATUS_CODE.workEnd;
    },
    // 是否显示至尊vip
    isShowZvVip() {
      return (
        this.taskDetail.tagCodes &&
        this.taskDetail.tagCodes.includes('VIP_CUSTOMER_ZV')
      );
    },
    // 是否显示黑钻客户
    isShowBcCustomer() {
      return (
        this.taskDetail.tagCodes &&
        this.taskDetail.tagCodes.includes('VIP_CUSTOMER_BC')
      );
    },
    // 至尊vip和重点保司
    isZvVipAndVipCompany() {
      return (
        this.taskDetail.vipCompany === '1' &&
        (this.isShowZvVip || this.isShowBcCustomer)
      );
    },
    topPromptDefaultText() {
      if (this.taskDetail && this.taskDetail.isPaicOrder === 1) {
        return '请务必引导客户5星好评、再去好车主app打10分';
      }
      return '';
    },
    // 是否地库牵引数量大于等于1
    hasUnderGround() {
      const {
        extraProduct
      } = this.taskDetail;
      const hasUnderGround = (extraProduct || []).some(item => item.desc === '00002' && item.value >= 1);

      return hasUnderGround;
    }
  },
  activated() {
    this.getRescueReport();
  },
  mounted() {
    this.queryDictByCodes();
    Util.initHistoryFix();
  },
  methods: {
    async getRescueReport() {
      try {
        const data = await getRescueReport({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.reportData = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    goWorkOrders() {
      const list = [];
      if (this.useShopDrawing) {
        list.push('地库牵引(1)');
      }
      if (this.trainingWheels) {
        list.push(`辅助轮(${this.trainingWheels})`); // 辅助轮
      }
      this.$router.push({
        name: 'WorkOrders',
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        },
        query: {
          extraProduct: list.length > 0 ? list.join(',') : '',
          isH5: true
        }
      });
    },
    copy(e) {
      handleClipboard(this.copyText, e);
    },
    getCeilNum(val) {
      return Math.round(val);
    },
    // 滑动到底
    async sliderCompleted() {
      if (!this.dataForm.address && !this.isShowTrailer) {
        this.showRequiredInfo();
        return;
      }
      if (!this.imageCompleted) {
        this.showImageInfo();
        return;
      }
      if (this.$refs.reasonSelectBox) {
        const result = await this.$refs.reasonSelectBox.validate();
        console.log(result);
        if (!result) {
          this.$refs.clickButton.reset();
          return;
        }
      }
      console.log(this.dataForm);
      try {
        if (!this.isShowTrailer) {
          this.showInfoConfirm();
        } else {
          this.savePictureTemplate();
        }
      } finally {
        this.$refs.clickButton.reset();
      }
    },
    showRequiredInfo() {
      const confirmText = '请输入终点地标';
      this.$refs.confirmDialog.open({
        confirmText,
        showCancelButton: false,
        confirmButtonText: '确定',
        confirmCallback: () => {
          this.$refs.clickButton.reset();
        },
        cancelCallback: () => {
          this.$refs.clickButton.reset();
        }
      });
    },
    showImageInfo() {
      const confirmText = this.imageInfo.requiredTips || '图片缺失';
      this.$refs.confirmDialog.open({
        confirmText,
        showCancelButton: false,
        confirmButtonText: '去拍照',
        confirmCallback: () => {
          this.toPhoto();
        },
        cancelCallback: () => {
          this.$refs.clickButton.reset();
        }
      });
    },
    showInfoConfirm() {
      const confirmObj = [
        {
          key: '类型',
          value: this.taskDetail.productCategoryName
        },
        {
          key: '救援环境',
          value: this.currentEnv
        },
        {
          key: '辅助轮数量',
          value: this.trainingWheels || '无'
        },
        {
          key: '地库牵引',
          value: this.useShopDrawing ? '有' : '无'
        }
      ];
      this.$refs.confirmDialog.open({
        confirmObj,
        cancelButtonText: '返回修改',
        confirmButtonText: '确认提交',
        confirmCallback: () => {
          this.savePictureTemplate();
        },
        cancelCallback: () => {
          this.$refs.clickButton.reset();
        }
      });
    },
    getPhotoParams() {
      // PICTURE_FINISH("006", "服务完成"),
      const params = {};
      if (this.isTrailer || this.isBasementTrailer) {
        params.useTraceCar = 1;
      } else if (this.isDifficultyRelief) {
        params.useTraceCar = this.taskDetail.useTraceCar;
      } else {
        params.useTraceCar = 0;
      }
      params.pictureTypes = ['006'];
      return params;
    },
    toPhoto() {
      const params = this.getPhotoParams();
      params.workerName = this.taskDetail.workerName;
      params.shopDrawing = this.hasUnderGround ? '1' : '0';
      console.log('toPhoto params:', params);

      this.jumpToNativePage('trailCompletedPage', params);
      this.$refs.clickButton.reset();
    },
    openEntryBox() {
      const title = `${
        this.taskDetail.appOrderPayType || ''
      }客户，请记录订单费用`;
      this.$refs.orderCostEntryBox.open({
        title,
        extraParam: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        },
        confirmCallback: (res) => {
          console.log('dataForm:', res);
        },
        cancelCallback: () => {}
      });
    },
    async queryDictByCodes() {
      try {
        const res = await queryDictByCodes({
          codes: [
            'rescueCurrentEnv' // 救援时当前环境
          ]
        });
        if (res) {
          this.currentEnvList = res.find(
            (item) => item.code === 'rescueCurrentEnv'
          ).kvs;
          this.getTaskDetail();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTaskDetail(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
          const { extraProduct } = this.taskDetail;
          (extraProduct || []).forEach((item) => {
            if (item.desc === '00001') {
              this.trainingWheels = item.value;
            } else if (item.desc === '00002') {
              this.useShopDrawing = item.value === 1;
            }
          });
          this.dataForm.address = this.taskDetail.actualGarageName;
          if (this.taskDetail.categoryCode === 'FL90000004') {
            this.isShowTrailer = true;
          } else {
            this.isShowTrailer = false;
          }
          this.getRightRemark();
          this.checkPictureNum();
          // 获取可复制的服务凭证信息
          this.getMediaTemplate();
          try {
            const res = await jsApi.hiddenCancelByStatus({
              taskStatus: this.taskDetail.taskStatus,
              appServiceType: this.taskDetail.appServiceType,
              orderNo: this.taskDetail.orderNo,
              taskNo: this.taskDetail.taskNo
            });
            if (res) {
              console.log(res);
            }
          } catch (error) {
            console.log(error);
          }
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取影像模板
    async getMediaTemplate() {
      const res = await getMediaTemplate({
        orderNo: this.orderNo,
        templateType: 'mainTemplate',
        source: 4
      });
      if (res) {
        const data = res || [];
        const arr = [];
        for (const item of data) {
          if (item.secondary) {
            const arr2 = [];
            for (const item2 of item.secondary) {
              if (item2.requiredNum > 0) {
                arr2.push(item2.typeName);
              }
            }
            if (arr2.length > 0) {
              arr.push(`${item.primaryName}(${arr2.join('、')})`);
            }
          }
        }
        this.copyText = this.taskDetail.orderNo + '\n' + arr.join('、');
      }
    },
    async getRightRemark() {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await getRightRemark({
          orderNo: this.orderNo
        });
        this.rightRemark = data.resultValue;
      } catch (error) {
        console.log(error);
      }
    },
    async checkPictureNum(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '正在更新图片数据...',
          forbidClick: true
        });
      }
      const params = this.getPhotoParams();
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await checkPictureNum({
          orderNo: this.orderNo,
          ...params
        });
        const { requiredNum, total, requiredTips } = data || {};
        this.imageCompleted = !isNaN(total) && total === requiredNum;
        this.imageInfo = {
          photoNumTaked: requiredNum,
          photoNumAll: total,
          requiredTips
        };
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async savePictureTemplate(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const params = this.getPhotoParams();
        await savePictureTemplate({
          orderNo: this.orderNo,
          taskNo: this.taskNo,
          ...params
        });
        if (!noLoading) {
          this.$toast.clear();
        }
        this.finishWork();
      } catch (error) {
        console.log(error);
      }
    },
    async finishWork(noLoading, skipCcqc006023WatermarkDistanceCheck = null, skipCcqcDistanceCheck = null) {
      if (!noLoading) {
        this.$toast.loading({
          message: '保存中...',
          forbidClick: true
        });
      }
      try {
        const { address } = this.dataForm;
        // 这个接口，还没返回值，后端就发送推送消息了
        const res = await finishWork({
          // 是否跳过拖车卸车完成照水印里程校验
          skipCcqc006023WatermarkDistanceCheck,
          skipCcqcDistanceCheck,
          taskNo: this.taskNo,
          actualGarageName: address
        });
        if (res && res.code) {
          if (res.code === '7011') {
            const confirmText3 = [
              {
                text: '申述里程/完成里程 与订单预估里程偏差过大不允许提审，请联系中保客服报备偏差原因：'
              },
              {
                text: '1、救援起点与系统不一致：请提供实际起点'
              },
              {
                text: '2、救援目的地与系统不一致：请提供实际目的地'
              },
              {
                text: '3、客户位置无法定位：请提供相关证明申诉里程的合理性'
              },
              {
                text: '4、封路需要绕路：请提供相关证明材料上传至拖车导航图'
              }
            ];
            this.$refs.confirmDialog.open({
              isConfirmDelay: true,
              delaySeconds: 5,
              confirmText3,
              cancelButtonText: '取消',
              confirmButtonText: '继续',
              confirmCallback: () => {
                this.finishWork(false, 1, 1);
              }
            });
            return;
          } else if (res.code === '7013') {
            const confirmText = res.message || '';
            this.$refs.confirmDialog.open({
              confirmText,
              confirmButtonText: '继续',
              confirmCallback: () => {
                this.finishWork(false, 1);
              }
            });
            return;
          } else if (res.code === '7014') {
            const confirmText = res.message || '';
            this.$refs.confirmDialog.open({
              isCancelDelay: true,
              delaySeconds: 5,
              confirmText,
              cancelButtonText: '关闭',
              showConfirmButton: false,
              confirmCallback: () => {
              }
            });
            return;
          }
        }
        jsApi.redPacketPopup({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        // 平安指定合作拖车终点的时候弹窗提示
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        this.$toast.clear();
        if (data) {
          const { cooperativeOutlet } = data;
          if (cooperativeOutlet === 1) {
            const confirmText2 = [
              {
                text: '拖车终点如果为平安合作加油站、充电站时，请同用户宣导使用'
              },
              {
                text: '好车主APP支付油费或扫码启动充电，享受优惠。',
                color: 'red'
              }
            ];
            this.$refs.confirmDialog.open({
              confirmText2,
              showCancelButton: false,
              confirmButtonText: '好的',
              confirmCallback: () => {
                this.toNextPage();
              },
              cancelCallback: () => {}
            });
            return;
          }
        }
        this.toNextPage();
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    toNextPage() {
      this.$router.replace({
        name: 'executed',
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        }
      });
    },
    // 跳转原生页面
    async jumpToNativePage(name, params = {}) {
      try {
        const res = await jsApi.jumpToNativePage({
          name,
          appServiceType: this.taskDetail.appServiceType,
          orderNo: this.orderNo,
          taskNo: this.taskNo,
          ...params
        });
        if (res) {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap-box {
  height: 100vh;
  .top-box {
    overflow-y: auto;

    height: calc(100vh - 82px);

    background: #f2f3f5;
  }
  .bottom {
    height: 82px;
  }
}
.flex-box {
  display: flex;
}
.content-box {
  padding: 12px;
  padding-bottom: 32px;

  .card-box {
    border-radius: 8px;
    background: #ffffff;

    .card-tips-warning {
      display: flex;
      align-items: center;
      justify-content: center;

      text-align: center;

      .tips-txt {
        margin-left: 5px;

        letter-spacing: -0.56px;

        color: #f32222;

        font-family: PingFangSC-Medium;
        font-size: 22px;
        font-weight: 500;
      }
    }

    & + .card-box {
      margin-top: 12px;
    }

    &.card-padding {
      padding: 16px;
    }

    &.card-padding-24 {
      padding: 24px 16px;
    }

    .info-item {
      letter-spacing: -0.38px;

      color: #383838;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      & + .info-item {
        margin-top: 12px;
      }
    }

    .item-label {
      color: #787878;
    }

    ::v-deep .card-title,
    .card-title {
      letter-spacing: -0.41px;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;

      &.card-title__center {
        text-align: center;
        letter-spacing: -0.38px;

        font-size: 15px;
        line-height: 21px;

        & .color-orange {
          color: #ff8a59;
        }
      }

      &.card-title-flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .card-title-info {
        display: flex;
        align-items: center;

        letter-spacing: -0.38px;

        color: #383838;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;

        .van-icon {
          margin-left: 8px;

          color: #999999;

          font-size: 16px;
        }
      }

      .card-tips {
        letter-spacing: -0.38px;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;

        &.card-tips__red {
          color: #f32222;
        }

        &.card-tips__small {
          letter-spacing: -0.31px;

          font-size: 12px;
          line-height: 17px;
        }

        &.card-tips__margin {
          margin-bottom: 10px;
        }
      }

      .card-tag {
        margin-left: 8px;
        padding: 1px 8px 2px;

        letter-spacing: -0.31px;

        border-radius: 2px;

        font-family: PingFangSC-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;

        &.card-tag__red {
          color: #c78062;
          background: #fff0ea;
        }
      }

      .card-text-btn {
        text-align: right;
        letter-spacing: -0.38px;

        color: #3399ff;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
      }
    }

    ::v-deep .van-checkbox {
      letter-spacing: -0.38px;

      color: #383838;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      .van-checkbox__icon {
        font-size: 16px;
        &.van-checkbox__icon--checked .van-icon {
          border-color: #3399ff;
          background-color: #3399ff;
        }
        .van-icon {
          border: 1px solid rgba(153, 153, 153, 1);
          border-radius: 4px;
        }
      }
    }

    .placeholder-box {
      margin-bottom: 24px;
    }

    .van-button {
      text-align: center;
      letter-spacing: -0.38px;

      color: #ffffff;
      border-radius: 8px;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      &.van-button--info {
        border-color: #3399ff;
        background-color: #3399ff;
      }

      &.van-button--large {
        height: 39px;
      }
    }
  }

  .select-box {
    .select-item {
      padding: 5px 10px;

      text-align: center;
      letter-spacing: -0.38px;

      color: #646464;
      border-radius: 4px;
      background: #e1e7ed;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;

      &.active {
        color: #ffffff;
        background: #3399ff;
      }
    }
  }
  .input-box {
    padding: 16px 0 8px;

    letter-spacing: -0.38px;

    border-radius: 8px;
    background: #ffffff;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    ::v-deep .van-field__control {
      color: #383838;

      &::placeholder {
        color: #c8c8c8;
      }
    }
  }

  ::v-deep .textarea-box {
    padding: 12px;

    letter-spacing: -0.38px;

    border: 1px solid rgba(200, 200, 200, 1);
    border-radius: 8px;
    background: #ffffff;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    ::v-deep .van-field__control {
      color: #383838;

      &::placeholder {
        color: #c8c8c8;
      }
    }
  }
  .car-info-item {
    display: flex;

    letter-spacing: -0.38px;

    color: #646464;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
    & + .car-info-item {
      padding-top: 8px;
    }
    .car_red {
      color: #f32222;
    }
    .vip-icon {
      width: 19px;
      height: 18px;
      margin-top: 2px;
      margin-left: 4px;
    }

    .zv-vip-icon {
      margin-left: 4px;
      margin-top: 2px;
      padding: 0 4px;
      text-align: center;
      letter-spacing: 0;
      color: #ffffff;
      border-radius: 4px;
      background: #f32222;
      font-family: PingFangSC-Regular;
      font-size: 10px;
      font-weight: 400;
      line-height: 18px;
      height: 18px;
      white-space: nowrap;
    }
    .copy {
      margin-left: 4px;
      padding: 0 5px;

      white-space: nowrap;

      color: #3399ff;
      border: 1px solid #3399ff;
      border-radius: 5px;
      background: #eaf4ff;

      font-size: 10px;
    }
    span {
      &:first-child {
        flex: 0 0 74px;
      }
      & + span {
        color: #383838;
      }
      &.car-no {
        font-family: PingFangSC-Medium;
        font-weight: 500;

        &.color-red {
          color: #f32222;
        }

        &.order-no {
          flex: 0 0 150px;

          word-break: break-all;
        }

        &.order-svip {
          flex: 0 0 100px;
          word-break: break-all;
        }
      }
    }
  }
  .card-extra {
    .card-title {
      margin-top: 10px;
      padding-top: 10px;

      border-top: 1px dashed #c8c8c8;
    }
    .extraProduct {
      box-sizing: border-box;
      margin-top: 10px;
      padding: 10px 20px;

      border-radius: 5px;
      background: #f4f4f4;
      .extraProductList {
        margin-top: 5px;

        font-size: 15px;
        .extraIndex {
          display: inline-block;

          width: 15px;
          height: 15px;

          text-align: center;

          border: 1px solid #000;
          border-radius: 50%;

          font-weight: 600;
          line-height: 15px;
        }
        .extraTitle {
          margin: 0 5px;

          font-weight: 600;
        }
      }
    }
  }
  .card-tips__gary {
    color: #787878;

    font-size: 12px;
  }
  .card-info {
    margin-top: 10px;

    color: #383838;

    font-size: 15px;
  }
  .card-tips__red {
    color: #f32222;
  }
}
.card-flex {
  display: flex;
  align-items: center;
}
.takeImg {
  width: 35px;
  margin-right: 10px;
}
.stateInfo {
  margin-right: 10px;

  color: #383838;

  font-size: 15px;
  font-weight: 400;
}
.isStateInfo {
  color: #f32222;
}
</style>
